module.exports = __webpack_public_path__ + "static/feature-2-20109a9c06ed43232881a846cc5a0694.svg";